export default "__VITE_ASSET__INp78_Zj__"